import { Timeline } from "antd";
import React from "react";
import moment from "moment";
import { REMOVE_AUDIT, VERIFICATION_STATUS } from "../../../../constants";
import { manipulateString } from "../RegistrationFormViewHelper";

let drop_models = [
  "attachment",
  "additionaldetails",
  "taxationdetails",
  "additionaldirectordetails",
  "additionalemails",
  "additionalsistercompany",
  "additionalmobilenumber",
  "additionaltelephonenumber"
];

class TimeLine extends React.Component {
  render() {
    if (
      this.props.versionList !== null &&
      this.props.versionList !== undefined &&
      this.props.versionList.length > 0
    ) {
      let changeFields;

      let x = [];

      x = this.props.versionList[1].map((item) => {
        if (item.change && Object.keys(item.change).length !== 0) {
          changeFields = Object.keys(item.change.values_changed);
          return (
            <Timeline.Item color="red">
              {changeFields.map((element) => {
                var a;
                a = element
                  .substring(element.indexOf("'"), element.indexOf("]"))
                  .replace(/'/g, "");
                if (
                  drop_models.includes(item.model) &&
                  item.action_taken == "Removed"
                ) {
                  return (
                    <span>
                      <b>
                        {moment(item.date, "YYYY-MM-DDTHH:mm:ss").format(
                          "DD-MM-YYYY HH:mm:ss"
                        )}{" "}
                        :{" "}
                      </b>
                      <b>{item.user}</b> Removed{" "}
                      <b>
                        {item.model
                          ? " " + manipulateString(item.model) + " "
                          : ""}
                        {item.name
                          ? " " + manipulateString(item.name) + " "
                          : item.id}
                      </b>{" "}
                      <br />
                    </span>
                  );
                } else {
                  if (a in VERIFICATION_STATUS) {
                    if (item.change.values_changed[element].new_value) {
                      return (
                        <span>
                          <b>
                            {moment(item.date, "YYYY-MM-DDTHH:mm:ss").format(
                              "DD-MM-YYYY HH:mm:ss"
                            )}{" "}
                            :{" "}
                          </b>
                          {VERIFICATION_STATUS[a]} by -- <b>{item.user}</b>
                          <br />
                        </span>
                      );
                    }
                  } else {
                   
                      return (
                        <span>
                          <b>
                            {moment(item.date, "YYYY-MM-DDTHH:mm:ss").format(
                              "DD-MM-YYYY HH:mm:ss"
                            )}{" "}
                            :{" "}
                          </b>
                          <b>{item.user}</b> Changed{" "}
                          <b>
                            {item.model
                              ? " " + manipulateString(item.model) + " - "
                              : ""}
                            {manipulateString(a)}{" "}
                          </b>
                          from{" "}
                          <b>
                            {item.change.values_changed[
                              element
                            ].old_value.toString()}
                          </b>{" "}
                          to
                          <b>
                            {" " +
                              item.change.values_changed[
                                element
                              ].new_value.toString()}
                          </b>
                          <br />
                        </span>
                      );
                   
                  }
                }
              })}
            </Timeline.Item>
          );
        } else {
          return (
            <Timeline.Item color="red">
              {
                <span>
                  <b>
                    {moment(item.date, "YYYY-MM-DDTHH:mm:ss").format(
                      "DD-MM-YYYY HH:mm:ss"
                    )}{" "}
                    :{" "}
                  </b>
                  <b>{item.user}</b> Added{" "}
                  <b>
                    {item.model ? " " + manipulateString(item.model) + " " : ""}
                    {item.name ? " " + manipulateString(item.name) + " " : ""}
                  </b>
                  <br />
                </span>
              }
            </Timeline.Item>
          );
        }
      });

      return (
        <Timeline>
          <Timeline.Item color="green">
            <p>
              <span>
                <b>
                  {moment(
                    this.props.versionList[0][0].created_at,
                    "YYYY-MM-DD"
                  ).format("YYYY-MM-DD")}
                </b>{" "}
                : Object Created by --{" "}
                <b>{this.props.versionList[0][0].created_by}</b>
              </span>
            </p>
          </Timeline.Item>
          {x}
        </Timeline>
      );
    } else {
      return <div></div>;
    }
  }
}

export default TimeLine;
